import { render } from "./SettingsFeaturesCard.vue?vue&type=template&id=67307ede&scoped=true"
import script from "./SettingsFeaturesCard.vue?vue&type=script&lang=js"
export * from "./SettingsFeaturesCard.vue?vue&type=script&lang=js"

import "./SettingsFeaturesCard.vue?vue&type=style&index=0&id=67307ede&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67307ede"]])

export default __exports__